import styles from './fullHero.module.css';
import SignupButton from '../signupbutton/signupbutton';

const FullHero = ({ imageUrl, altText, headline, paragraph, cta, ctaLink, height }) => {
    return (
        <div className={styles.fullScreenContainer}>
            <img 
                    className={styles.fullScreenBackgroundImage} 
                    src={imageUrl || "https://visitfaroeislands.com/download/kirstinvangbikesuuroy_large.jpg"}
                    alt={altText || "bakgrundsmynd"}
                />
                <div className={styles.fullScreenContentOverlay}>

                    {headline && <h1 className={styles.frontpageTitle}>{headline}</h1>}
                    {paragraph && <p className={styles.frontpageDescription}>{paragraph}</p>}
                    {cta && <SignupButton text={cta} ctaLink={"https://sukkla.fo/limir"} />}

                </div>
        </div>
    );
}

export default FullHero;
